(function () {
  var TRACKING_ASSET_VERSION = '2026-07-15-accepted-lead-events';
  var SHARE_LEAD_DELIVERY_ENDPOINT = 'https://shareos-production.up.railway.app/api/share-restoration/lead-delivery';

  if (window.__shareRestorationTrackingLoaded) return;
  window.__shareRestorationTrackingLoaded = true;

  var PHONE_CLICK_FALLBACK_DELAY = 350;
  var PHONE_CLICK_MATCH_WINDOW = 900;
  var observedPhoneClicks = [];
  var acceptedLeadKeys = {};

  window.dataLayer = window.dataLayer || [];

  function getLeadAttribution() {
    var storageKey = 'share_restoration_first_touch_v1';
    var params = new URLSearchParams(window.location.search);
    var current = {
      landingPageUrl: window.location.href,
      referrerUrl: document.referrer || '',
      utmSource: params.get('utm_source') || '',
      utmMedium: params.get('utm_medium') || '',
      utmCampaign: params.get('utm_campaign') || '',
      utmTerm: params.get('utm_term') || '',
      utmContent: params.get('utm_content') || '',
      gclid: params.get('gclid') || '',
      gbraid: params.get('gbraid') || '',
      wbraid: params.get('wbraid') || '',
      msclkid: params.get('msclkid') || ''
    };
    var saved = null;

    try {
      saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      if (!saved) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(current));
        saved = current;
      }
    } catch (storageError) {
      saved = current;
    }

    return saved || current;
  }

  window.ShareRestorationLeadAttribution = getLeadAttribution;
  getLeadAttribution();

  function parseLeadDeliveryBody(init) {
    var body = init && init.body;

    if (typeof body !== 'string') return null;

    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  }

  function leadTypeFromPayload(payload) {
    return payload && payload.formType === 'plumber-match-request'
      ? 'plumber_dispatch'
      : 'water_damage_assessment';
  }

  function leadDeliveryEvent(payload, eventName, deliveryStatus) {
    var leadType = leadTypeFromPayload(payload);

    return {
      event: eventName,
      event_category: 'lead',
      event_action: deliveryStatus,
      lead_type: leadType,
      form_type: (payload && payload.formType) || '',
      lead_source: (payload && payload.leadSource) || '',
      lead_urgency: (payload && payload.urgency) || '',
      lead_property_type: (payload && payload.propertyType) || 'Not provided',
      lead_damage_situation: (payload && payload.damageSituation) || 'Not provided',
      lead_water_status: (payload && payload.waterStatus) || 'Not provided',
      lead_area_present: payload && payload.area ? 'yes' : 'no',
      lead_phone_present: payload && payload.customerPhone ? 'yes' : 'no',
      lead_email_present: payload && payload.customerEmail ? 'yes' : 'no',
      landing_page_path: (payload && payload.leadPath) || window.location.pathname,
      first_touch_source: (payload && payload.utmSource) || '',
      first_touch_medium: (payload && payload.utmMedium) || '',
      first_touch_campaign: (payload && payload.utmCampaign) || '',
      first_touch_term: (payload && payload.utmTerm) || '',
      gclid_present: payload && payload.gclid ? 'yes' : 'no',
      gbraid_present: payload && payload.gbraid ? 'yes' : 'no',
      wbraid_present: payload && payload.wbraid ? 'yes' : 'no',
      share_tracking_version: 'delivery_accepted_v1',
      share_tracking_asset_version: TRACKING_ASSET_VERSION
    };
  }

  function emitLeadDeliveryResult(payload, accepted) {
    var key;
    var eventName = accepted ? 'share_lead_delivery_accepted' : 'share_lead_delivery_failed';
    var eventPayload;

    if (!payload) return;

    key = [payload.formType, payload.submittedAt, payload.leadPath].join('|');
    if (accepted && acceptedLeadKeys[key]) return;
    if (accepted) acceptedLeadKeys[key] = true;

    eventPayload = leadDeliveryEvent(payload, eventName, accepted ? 'delivery_accepted' : 'delivery_failed');
    window.dataLayer.push(eventPayload);

    if (accepted) {
      window.dataLayer.push(leadDeliveryEvent(
        payload,
        leadTypeFromPayload(payload) === 'plumber_dispatch'
          ? 'share_plumber_dispatch_accepted'
          : 'share_water_lead_accepted',
        'delivery_accepted'
      ));
    }
  }

  function installLeadDeliveryFetchBridge() {
    var originalFetch = window.fetch;

    if (window.__shareLeadDeliveryFetchBridgeInstalled) return;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function (input, init) {
      var target = typeof input === 'string' ? input : input && input.url;
      var payload = target === SHARE_LEAD_DELIVERY_ENDPOINT ? parseLeadDeliveryBody(init) : null;
      var request = originalFetch.apply(this, arguments);

      if (!payload || !request || typeof request.then !== 'function') return request;

      return request.then(function (response) {
        emitLeadDeliveryResult(payload, Boolean(response && response.ok));
        return response;
      }, function (error) {
        emitLeadDeliveryResult(payload, false);
        throw error;
      });
    };

    window.__shareLeadDeliveryFetchBridgeInstalled = true;
  }

  function findAssessmentForm() {
    return document.querySelector('[id^="ShareLeadWaterAssessmentForm-"]');
  }

  function markAssessmentDeliveryStatus(status) {
    var form = findAssessmentForm();

    if (!form) return;

    try {
      form.setAttribute('data-share-lead-delivery-status', status);
    } catch (error) {}
  }

  function installAssessmentBeaconDeliveryBridge() {
    var originalSendBeacon = navigator.sendBeacon;

    if (window.__shareAssessmentBeaconDeliveryBridgeInstalled) return;
    if (typeof originalSendBeacon !== 'function') return;

    try {
      navigator.sendBeacon = function (url, data) {
        var target = String(url || '');

        if (target !== SHARE_LEAD_DELIVERY_ENDPOINT) {
          return originalSendBeacon.apply(navigator, arguments);
        }

        try {
          fetch(target, {
            method: 'POST',
            body: data,
            mode: 'cors',
            credentials: 'same-origin',
            keepalive: true
          }).then(function (response) {
            markAssessmentDeliveryStatus(response.ok ? 'accepted' : 'failed');
            if (!response.ok) originalSendBeacon.call(navigator, url, data);
          }).catch(function () {
            markAssessmentDeliveryStatus('failed');
            originalSendBeacon.call(navigator, url, data);
          });

          markAssessmentDeliveryStatus('fetch-started');
          return true;
        } catch (error) {
          return originalSendBeacon.apply(navigator, arguments);
        }
      };

      window.__shareAssessmentBeaconDeliveryBridgeInstalled = true;
    } catch (error) {}
  }

  function installAssessmentGtagGuard() {
    var originalGtag;
    var guardedEvents = {
      form_submit: true,
      generate_lead: true,
      share_lead_assessment_submit: true
    };

    if (window.__shareAssessmentGtagGuardInstalled) return;

    originalGtag = window.gtag;

    window.gtag = function () {
      var command = arguments[0];
      var eventName = arguments[1];
      var params = arguments[2] || {};
      var isStaleAssessmentSubmit =
        command === 'event' &&
        guardedEvents[eventName] &&
        params.share_tracking_version !== 'gtm_single_submit_v1' &&
        (params.event_action === 'lead_assessment_submit' || params.lead_type === 'water_damage_assessment');

      if (isStaleAssessmentSubmit) {
        window.dataLayer.push({
          event: 'share_assessment_stale_gtag_suppressed',
          share_tracking_source: 'share-restoration-events',
          share_tracking_asset_version: TRACKING_ASSET_VERSION
        });
        return;
      }

      if (typeof originalGtag === 'function') {
        return originalGtag.apply(this, arguments);
      }

      window.dataLayer.push(arguments);
    };

    window.__shareAssessmentGtagGuardInstalled = true;
  }

  installAssessmentBeaconDeliveryBridge();
  installAssessmentGtagGuard();
  installLeadDeliveryFetchBridge();

  function normalizePhone(value) {
    var digits = String(value || '').replace(/^tel:/i, '').replace(/\D/g, '');

    if (digits.length === 10) {
      return '+1' + digits;
    }

    if (digits.length === 11 && digits.charAt(0) === '1') {
      return '+' + digits;
    }

    return digits ? '+' + digits : '';
  }

  function getText(element) {
    return String((element && (element.innerText || element.textContent)) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 160);
  }

  function getSectionName(element) {
    var section = element.closest('[data-section-type], section, header, footer, nav, .shopify-section');

    if (!section) return '';
    if (section.id) return section.id;
    if (section.getAttribute('data-section-type')) return section.getAttribute('data-section-type');
    if (section.className && typeof section.className === 'string') {
      return section.className.replace(/\s+/g, ' ').trim().slice(0, 120);
    }

    return section.tagName ? section.tagName.toLowerCase() : '';
  }

  function getBasePayload(element, eventType) {
    var href = element.href || element.getAttribute('href') || '';
    var idElement = element.id ? element : element.closest('[id]');
    var ctaElement = element.hasAttribute && element.hasAttribute('data-share-cta')
      ? element
      : element.closest('[data-share-cta]');
    var outboundDomain = '';

    try {
      if (href && !String(href).toLowerCase().startsWith('tel:') && !String(href).toLowerCase().startsWith('mailto:')) {
        var targetUrl = new URL(href, window.location.href);
        if (targetUrl.hostname && targetUrl.hostname !== window.location.hostname) outboundDomain = targetUrl.hostname;
      }
    } catch (error) {}

    return {
      event_category: 'engagement',
      event_action: eventType,
      click_text: getText(element),
      click_url: href,
      link_url: href,
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      click_section: getSectionName(element),
      click_id: (idElement && idElement.id) || '',
      click_classes: String(element.className || '').replace(/\s+/g, ' ').trim().slice(0, 160),
      cta_name: (ctaElement && ctaElement.getAttribute('data-share-cta')) || '',
      outbound_domain: outboundDomain
    };
  }

  function getGtagParams(payload) {
    var params = {};
    var allowedKeys = [
      'event_category',
      'event_action',
      'click_text',
      'click_url',
      'link_url',
      'page_location',
      'page_path',
      'page_title',
      'click_section',
      'click_id',
      'click_classes',
      'phone_number',
      'phone_digits',
      'phone_area_code',
      'email_link',
      'link_type',
      'cta_name',
      'outbound_domain',
      'form_id',
      'form_name',
      'form_action',
      'form_method',
      'form_type',
      'lead_type'
    ];

    allowedKeys.forEach(function (key) {
      if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
        params[key] = payload[key];
      }
    });

    return params;
  }

  function pushGtagEvent(payload) {
    if (!payload || !payload.event || payload.event.indexOf('share_') !== 0) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', payload.event, getGtagParams(payload));
  }

  function pushDataLayer(payload) {
    window.dataLayer.push(payload);
    pushGtagEvent(payload);
  }

  function observePhoneClickFromDataLayer(item) {
    if (!item || item.event !== 'gtm.click') return;

    var elementUrl = item['gtm.elementUrl'] || item.click_url || '';
    if (!String(elementUrl).toLowerCase().startsWith('tel:')) return;

    observedPhoneClicks.push({
      phone: normalizePhone(elementUrl),
      url: elementUrl,
      at: Date.now()
    });

    observedPhoneClicks = observedPhoneClicks.slice(-30);
  }

  function wrapDataLayerPush() {
    if (window.dataLayer.__shareRestorationWrapped) return;

    var originalPush = window.dataLayer.push.bind(window.dataLayer);

    window.dataLayer.push = function () {
      Array.prototype.forEach.call(arguments, observePhoneClickFromDataLayer);
      return originalPush.apply(window.dataLayer, arguments);
    };

    window.dataLayer.__shareRestorationWrapped = true;
    window.dataLayer.forEach(observePhoneClickFromDataLayer);
  }

  function sawNativePhoneClick(phone, clickTime) {
    return observedPhoneClicks.some(function (item) {
      return item.phone === phone && item.at >= clickTime - 50 && item.at <= clickTime + PHONE_CLICK_MATCH_WINDOW;
    });
  }

  function pushSyntheticGtmClick(link, payload, clickTime) {
    var phone = payload.phone_number;

    window.setTimeout(function () {
      if (sawNativePhoneClick(phone, clickTime)) return;

      pushDataLayer({
        event: 'gtm.click',
        'gtm.element': link,
        'gtm.elementUrl': link.href || link.getAttribute('href') || '',
        'gtm.elementText': payload.click_text,
        share_restoration_synthetic: true,
        share_tracking_source: 'share-restoration-events'
      });
    }, PHONE_CLICK_FALLBACK_DELAY);
  }

  function handlePhoneClick(link) {
    var clickTime = Date.now();
    var payload = getBasePayload(link, 'phone_click');
    var phoneNumber = normalizePhone(payload.click_url);

    payload.event = 'share_phone_click';
    payload.phone_number = phoneNumber;
    payload.phone_digits = phoneNumber.replace(/\D/g, '');
    payload.phone_area_code = payload.phone_digits.length >= 10 ? payload.phone_digits.slice(-10, -7) : '';

    pushDataLayer(payload);
    pushSyntheticGtmClick(link, payload, clickTime);
  }

  function handleEmailClick(link) {
    var payload = getBasePayload(link, 'email_click');

    payload.event = 'share_email_click';
    payload.email_link = payload.click_url.replace(/^mailto:/i, '').split('?')[0];

    pushDataLayer(payload);
  }

  function handleGenericClick(element) {
    var payload = getBasePayload(element, 'click');

    payload.event = 'share_click';
    payload.link_type = element.tagName && element.tagName.toLowerCase() === 'button' ? 'button' : 'link';

    pushDataLayer(payload);
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a[href]');
    if (link) {
      var href = String(link.getAttribute('href') || '');

      if (href.toLowerCase().startsWith('tel:')) {
        handlePhoneClick(link);
        return;
      }

      if (href.toLowerCase().startsWith('mailto:')) {
        handleEmailClick(link);
        return;
      }

      handleGenericClick(link);
      return;
    }

    var button = target.closest('button, [role="button"], input[type="submit"], input[type="button"]');
    if (button) handleGenericClick(button);
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;

    var payload = getBasePayload(form, 'form_submit');

    payload.event = 'share_form_submit';
    payload.form_id = form.id || '';
    payload.form_name = form.getAttribute('name') || '';
    payload.form_action = form.action || '';
    payload.form_method = form.method || '';

    pushDataLayer(payload);
    pushDataLayer({
      event: 'form_submit',
      share_event_alias: 'share_form_submit',
      form_id: payload.form_id,
      form_name: payload.form_name,
      form_action: payload.form_action,
      form_method: payload.form_method,
      page_location: payload.page_location,
      page_path: payload.page_path,
      page_title: payload.page_title
    });
  }

  function handleFormStart(event) {
    var field = event.target;
    var form = field && field.form;
    var root;
    var payload;

    if (!form || form.getAttribute('data-share-form-started') === 'true') return;
    if (!form.closest('[data-lead-delivery-endpoint]')) return;

    form.setAttribute('data-share-form-started', 'true');
    root = form.closest('[data-lead-delivery-endpoint]');
    payload = getBasePayload(form, 'form_start');
    payload.event = 'share_form_start';
    payload.form_id = form.id || '';
    payload.form_name = form.getAttribute('name') || '';
    payload.form_type = window.location.pathname.indexOf('plumber') !== -1
      ? 'plumber-match-request'
      : 'water-damage-assessment';
    payload.lead_type = payload.form_type === 'plumber-match-request'
      ? 'plumber_dispatch'
      : 'water_damage_assessment';
    payload.lead_source = root.getAttribute('data-lead-source') || '';

    pushDataLayer(payload);
  }

  function correctDallasSuiteText(root) {
    if (!root || !document.createTreeWalker || typeof NodeFilter === 'undefined') return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (/^(script|style|noscript|textarea)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return node.nodeValue && node.nodeValue.indexOf('Southwell') !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      var original = node.nodeValue;
      var corrected = original
        .replace(/2510 Southwell Road #118/g, '2510 Southwell Road #114')
        .replace(/2510 Southwell Rd #118/g, '2510 Southwell Rd #114')
        .replace(/2510 Southwell Road #114/g, '2510 Southwell Road #114')
        .replace(/2510 Southwell Rd #114/g, '2510 Southwell Rd #114');

      if (corrected !== original) node.nodeValue = corrected;
    }
  }

  function runDallasSuiteCorrection() {
    correctDallasSuiteText(document.body);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        correctDallasSuiteText(document.body);
      }, { once: true });
    }
  }

  function installBurstPipeAssessmentPatch() {
    var oldBurstPath = '/pages/burst-pipe-water-cleanup-dallas-fort-worth';
    var burstPath = '/pages/burst-pipe-cleanup-dallas-fort-worth';
    if (window.location.pathname !== burstPath && window.location.pathname !== oldBurstPath) return;
    if (window.__shareBurstPipeAssessmentPatchInstalled) return;
    window.__shareBurstPipeAssessmentPatchInstalled = true;

    var leadSource = 'Burst Pipe Water Cleanup page';
    var leadPageLabel = 'Burst Pipe Water Cleanup';
    var leadHeading = 'Burst Pipe and Plumbing Leak Cleanup';
    var firstQuestion = 'Where is the burst pipe or leak?';
    var firstQuestionUrl = burstPath;

    function fieldValue(form, name) {
      var field = form && form.elements ? form.elements[name] : null;
      return field && field.value ? field.value.trim() : '';
    }

    function updateNamedField(form, name, value) {
      var field = form && form.elements ? form.elements[name] : null;
      if (field) field.value = value;
    }

    function getAssessmentUrgency(damage, water) {
      if (water === 'Water is still active' || damage === 'Sewage backup') return 'Immediate callback recommended';
      if (damage === 'Flooding or storm water') return 'Priority callback recommended';
      return 'Standard callback';
    }

    function buildAssessmentPayload(form) {
      var damage = fieldValue(form, 'contact[Damage situation]');
      var water = fieldValue(form, 'contact[Water status]');
      var attribution = getLeadAttribution();

      return {
        leadSource: leadSource,
        formType: 'burst-pipe-assessment',
        leadPage: window.location.origin + window.location.pathname,
        leadPath: window.location.pathname,
        landingPageUrl: attribution.landingPageUrl,
        referrerUrl: attribution.referrerUrl,
        utmSource: attribution.utmSource,
        utmMedium: attribution.utmMedium,
        utmCampaign: attribution.utmCampaign,
        utmTerm: attribution.utmTerm,
        utmContent: attribution.utmContent,
        gclid: attribution.gclid,
        gbraid: attribution.gbraid,
        wbraid: attribution.wbraid,
        msclkid: attribution.msclkid,
        submittedAt: new Date().toISOString(),
        urgency: getAssessmentUrgency(damage, water),
        area: fieldValue(form, 'contact[ZIP or city]'),
        propertyType: fieldValue(form, 'contact[Property type]'),
        damageSituation: damage,
        waterStatus: water,
        customerName: fieldValue(form, 'contact[name]'),
        customerPhone: fieldValue(form, 'contact[phone]'),
        customerEmail: fieldValue(form, 'contact[email]'),
        customerNotes: fieldValue(form, 'contact[Customer notes]')
      };
    }

    function writeAssessmentSummary(form, payload) {
      updateNamedField(form, 'contact[Lead page]', leadPageLabel);
      updateNamedField(form, 'contact[Lead page URL]', payload.leadPage);
      updateNamedField(form, 'contact[Lead urgency]', payload.urgency);

      var body = form && form.elements ? form.elements['contact[body]'] : null;
      if (body) {
        body.value = [
          'Burst pipe and plumbing leak cleanup lead.',
          'Lead source: ' + payload.leadSource,
          'Urgency: ' + payload.urgency,
          'Area: ' + payload.area,
          'Property type: ' + payload.propertyType,
          'Damage situation: ' + payload.damageSituation,
          'Water status: ' + payload.waterStatus,
          'Name: ' + payload.customerName,
          'Phone: ' + payload.customerPhone,
          'Email: ' + payload.customerEmail,
          'Notes: ' + payload.customerNotes,
          'Lead page: ' + payload.leadPage
        ].join('\n');
      }
    }

    function pushAssessmentEvents(form, payload) {
      if (form && form.getAttribute('data-share-lead-analytics-sent') === 'true') return;
      if (form) form.setAttribute('data-share-lead-analytics-sent', 'true');

      var base = {
        event_category: 'lead',
        event_action: 'lead_assessment_submit',
        lead_type: 'water_damage_assessment',
        share_tracking_version: 'gtm_single_submit_v1',
        lead_source: payload.leadSource,
        lead_urgency: payload.urgency,
        lead_property_type: payload.propertyType || 'Not provided',
        lead_damage_situation: payload.damageSituation || 'Not provided',
        lead_water_status: payload.waterStatus || 'Not provided',
        lead_area_present: payload.area ? 'yes' : 'no',
        lead_phone_present: payload.customerPhone ? 'yes' : 'no',
        lead_email_present: payload.customerEmail ? 'yes' : 'no',
        form_id: form && form.id || '',
        form_name: form && form.getAttribute('name') || 'contact',
        form_action: form && form.action || '',
        form_method: form && form.method || '',
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title
      };

      function copy(name) {
        var item = { event: name };
        Object.keys(base).forEach(function(key) {
          item[key] = base[key];
        });
        if (name === 'form_submit' || name === 'generate_lead') item.share_event_alias = 'share_lead_assessment_submit';
        return item;
      }

      window.dataLayer.push(copy('share_lead_assessment_submit'));
      window.dataLayer.push(copy('form_submit'));
      window.dataLayer.push(copy('generate_lead'));
    }

    function deliverAssessmentLead(form, payload) {
      if (!form) return;
      if (form.getAttribute('data-share-burst-pipe-delivered') === 'true') return;

      form.setAttribute('data-share-burst-pipe-delivered', 'true');
      form.setAttribute('data-share-inline-delivered', 'true');
      markAssessmentDeliveryStatus('fetch-started');
      pushAssessmentEvents(form, payload);

      var body = JSON.stringify(payload);

      fetch(SHARE_LEAD_DELIVERY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        mode: 'cors',
        credentials: 'same-origin',
        keepalive: true
      }).then(function(response) {
        markAssessmentDeliveryStatus(response.ok ? 'accepted' : 'failed');
        if (!response.ok && navigator.sendBeacon) {
          navigator.sendBeacon(SHARE_LEAD_DELIVERY_ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        }
      }).catch(function() {
        markAssessmentDeliveryStatus('failed');
        if (navigator.sendBeacon) navigator.sendBeacon(SHARE_LEAD_DELIVERY_ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      });
    }

    function patchAssessmentCopy() {
      var root = document.querySelector('[id^="ShareLeadWaterAssessment-"]');
      if (root) root.setAttribute('data-lead-source', leadSource);

      var title = document.querySelector('[id^="ShareLeadWaterAssessment-"][id$="-title"], .sr-lead-assessment__sr-only');
      if (title) title.textContent = leadHeading;

      var questionLink = document.querySelector('.sr-lead-assessment__question h2 a');
      if (questionLink) {
        questionLink.textContent = firstQuestion;
        questionLink.setAttribute('href', firstQuestionUrl);
      }

      var form = findAssessmentForm();
      if (form) {
        updateNamedField(form, 'contact[Lead page]', leadPageLabel);
        updateNamedField(form, 'contact[Lead page URL]', window.location.origin + window.location.pathname);
      }
    }

    function handleAssessmentIntent(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('[data-lead-submit]');
      if (!button || !button.form) return;

      patchAssessmentCopy();

      if (typeof button.form.checkValidity === 'function' && !button.form.checkValidity()) return;

      var payload = buildAssessmentPayload(button.form);
      writeAssessmentSummary(button.form, payload);
      deliverAssessmentLead(button.form, payload);
    }

    patchAssessmentCopy();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', patchAssessmentCopy, { once: true });
    }

    window.setTimeout(patchAssessmentCopy, 500);
    window.setTimeout(patchAssessmentCopy, 1500);
    document.addEventListener('pointerdown', handleAssessmentIntent, true);
    document.addEventListener('click', handleAssessmentIntent, true);
  }

  wrapDataLayerPush();
  runDallasSuiteCorrection();
  installBurstPipeAssessmentPatch();
  document.addEventListener('click', handleClick, true);
  document.addEventListener('input', handleFormStart, true);
  document.addEventListener('change', handleFormStart, true);
  document.addEventListener('submit', handleSubmit, true);

  window.ShareRestorationTracking = {
    normalizePhone: normalizePhone
  };
})();
